import React, { useEffect, useState } from 'react'
import MobileNavbarInside from '../../MobGlobalComponents/MobileNavbar/MobileNavbarInside'
import ReactStars from 'react-stars'
import { withCreateReview } from '../../../Desktop/Pages/ProductDetails/HOCs/withCreateReview'

const MobileCreateReview = ({ productDetails, formData, handleImageChange, productReviewSubmit, selectedImage, handleChange, handleRatingClick }) => {
	const [delayedImages, setDelayedImages] = useState([])

	useEffect(() => {
		if (selectedImage?.timestampedFile?.length > 0) {
			const timer = setTimeout(() => {
				setDelayedImages(selectedImage.timestampedFile)
			}, 2000) // Delay for 2 seconds

			return () => clearTimeout(timer) // Cleanup on unmount
		}
	}, [selectedImage?.timestampedFile])
	return (
		<>
			<div className='display-mob'>
				<MobileNavbarInside />
				<div className='container-fluid'>
					<div className='d-flex mx-auto mt-6 justify-content-start align-items-center'>
						<div>
							<img
								src={`${process.env.REACT_APP_RESOURCE_URL}${productDetails?.productImageUrl ?? productDetails?.imageUrl}`}
								className='img-fluid-review'
								alt='...'
								style={{ width: '100px' }}
							/>
						</div>
						<div>
							<h4 className=' text-black fw-normal px-4'>Write a product review</h4>
						</div>
					</div>
					<hr className=' horizontal dark' />
					<div className=' mt-3 mb-3'>
						<div>
							<b className=' text-black fw-bold fs-6'>How would you rate it?</b>
						</div>
						<span className=' d-flex gap-2'>
							<ReactStars
								name='rating'
								count={5}
								value={formData.rating} // Current rating value from state
								onChange={handleRatingClick} // Function to handle rating change
								size={24}
								color2={'#4caf50'}
								edit={true} // Set to true for user interaction
								half={false}
							/>
						</span>
					</div>
					<div className=' mt-3 mb-3'>
						<div>
							<b className=' text-black fw-bold fs-6'>Share photos</b>
						</div>
						{formData?.reviewImages &&
							formData?.reviewImages?.length > 0 &&
							formData?.reviewImages
								?.filter((img) => img.startsWith('reviews/'))
								.map((img, index) => (
									<img
										key={index}
										src={`${process.env.REACT_APP_RESOURCE_URL}${img}`}
										alt={`Uploaded preview ${index + 1}`}
										style={{ width: '100px', padding: '5px', marginTop: '10px' }}
									/>
								))}
						{delayedImages.length > 0 &&
							delayedImages.map((image, index) => (
								<img
									key={index}
									src={`${process.env.REACT_APP_RESOURCE_URL}reviews/${image?.name}`}
									alt='Uploaded preview'
									style={{ width: '100px', padding: '5px', marginTop: '10px' }}
								/>
							))}

						<div className=' border-radius-2xl'>
							<div className=' d-flex justify-content-center align-items-center img-upload-card mt-2 position-relative'>
								<i class='bi bi-camera-fill fs-1 opacity-4'></i>
								<input
									type='file'
									multiple
									onChange={handleImageChange}
									className='position-absolute w-100 h-100 opacity-0 cursor-pointer'
									style={{ top: 0, left: 0 }}
								/>
							</div>
						</div>
					</div>
					<div className=' mt-3 mb-3'>
						<div>
							<b className=' text-black fw-bold fs-6'>Title your review</b>
						</div>
						<div className=' input-group input-group-outline input-group-lg mt-2'>
							<input
								type='text'
								className=' form-control'
								placeholder="What's most important to know?"
								name='title'
								value={formData?.title}
								onChange={handleChange}
							/>
						</div>
					</div>
					<div className=' mt-3 mb-3'>
						<div>
							<b className=' text-black fw-bold fs-6'>Write your review</b>
						</div>
						<div className=' input-group input-group-outline input-group-lg mt-2'>
							<textarea
								type='text'
								rows='6'
								className=' form-control'
								placeholder='What did you like or dislike?'
								name='review'
								value={formData?.review}
								onChange={handleChange}
							/>
						</div>
					</div>
				</div>
			</div>
			<div className=' fixed-bottom justify-content-center text-center mb-2'>
				<button className=' btn btn-lg btn-yellow w-95' onClick={() => productReviewSubmit()}>
					Submit
				</button>
			</div>
		</>
	)
}

export default withCreateReview(MobileCreateReview)
